import { motion, AnimatePresence } from "framer-motion";
import { Button } from "./Controls/Button";
import { usePendingChanges } from "./PendingChangesContext";

export function SaveChangesBar() {
  const { hasChanges, onSave, onDiscard } = usePendingChanges();

  return (
    <AnimatePresence>
      {hasChanges && (
        <motion.div
          initial={{ y: 100, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 100, opacity: 0 }}
          transition={{ duration: 0.25, ease: "easeOut" }}
          className="position-fixed bottom-0 start-0 end-0 bg-white border-top shadow-lg"
          style={{ zIndex: 100 }}
        >
          <div className="container-fluid py-3 d-flex justify-content-end gap-3">
            <Button onClick={() => onDiscard?.()}>Discard</Button>

            <Button className="btn-main" onClick={onSave}>
              Save Changes
            </Button>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
